import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import Joi from 'joi-browser';

import { CompanyService } from '../services/Companies';
import { CompanyBranchService } from '../services/CompanyBranches';
import { UserProfileService } from '../services/UserProfiles';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { CompanyBranchForm } from '../components/forms/PrimeBranch'; // フォーム
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';

import dialogLoader from '../utilities/dialogLoader';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import regex from '../utilities/validateRegex';
import { validationByJoi } from '../utilities/commonValidation';
import {
  HEADER_CONSTANTS, // ヘッダータイトル
  BILLING_FLAG, // 請求先フラグ
  DIALOG_STATUS,
} from '../utilities/constants';
import {
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../utilities/stringUtil';
import { onceAsyncRequest } from '../utilities/commonUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { FormInformationDialog } from '../components/FormInformationDialog';
import ConfirmationSafetyDocItemDialog from '../components/worker/dialog/ConfirmationSafetyDocItemDialog';
import Style from '../styles/componentStyle/worker/insuranceInfo/insuranceInfo.scss';

export class PrimeBranchEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: localStorage.getItem('user_id'),
      companyId: SessionStorageService.getCompanyId(),
      branchId: this.props.view.state.id, // 支店Id
      use_greenfile_flg: '', // 労務安全使用フラグ
      requiredInput: {
        // 必須入力項目
        columns: [
          'name',
          'kana',
          'postal_code',
          'prefectures_code_id',
          'city_name',
          'street_number',
          'tel',
          'charge_name',
          'charge_name_kana',
          'email',
        ], // 必須項目名
        hasBilling: [
          'postal_code',
          'prefectures_code_id',
          'city_name',
          'street_number',
          'tel',
          'charge_name',
          'charge_name_kana',
          'email',
        ], // 支店
        total: 0, // 必須総数
        count: 0, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      formValues: {
        company_id: '',
        billing_target_id: '',
        name: '',
        kana: '',
        postal_code: '',
        prefectures_code_id: '',
        city_name: '',
        street_number: '',
        building_name: '',
        tel: '',
        fax: '',
        charge_name: '',
        charge_name_kana: '',
        department: '',
        job_title: '',
        email: '',
        use_partner_company_approval_default_flag: '',
        billing_flag: '',
        billing_target: {
          postal_code: '',
          prefectures_code_id: '',
          city_name: '',
          street_number: '',
          building_name: '',
          tel: '',
          fax: '',
          charge_name: '',
          charge_name_kana: '',
          department: '',
          job_title: '',
          email: '',
        },
      },
      dialogStatus: DIALOG_STATUS.disabled.id,
      confirmationModalSafetyDocItem: {
        // 安全書類項目用バリデート
        errorPropertyList: [],
      },
      expirationCompany: {},
    };

    this.updatingFlag = false; // 連打防止用フラグ

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.submit = this.submit.bind(this); // 会社登録
    this.validate = this.validate.bind(this); // バリデーション
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視

    // イベント登録
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBackDialog.bind(this), // 閉じる
      },
      form: {
        // フォーム関連
        set: this.setBranch.bind(this), // 支店情報入力
        setBilling: this.setBilling.bind(this), // 請求先情報入力
        update: this.update.bind(this), // 更新
        validate: this.validate.bind(this),
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        clear: () => {
          const id = this.props.view.state.id;
          _masterSlideLoader.show('PrimeBranchPreview', { state: { id } });
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };

    this.billingValidate = {};

    this.schema = {
      company_id: Joi.allow(null, ''),
      billing_target_id: Joi.allow(null, ''),
      name: Joi.string()
        .trim()
        .required()
        .max(255), // 支店名
      kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(512), // 支店名ふりがな
      postal_code: Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .required(), // 郵便番号
      prefectures_code_id: Joi.number().required(), // 都道府県
      city_name: Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .required()
        .max(512), // 市区町村
      street_number: Joi.string()
        .required()
        .max(512), // 丁目・番地
      building_name: Joi.string()
        .max(512)
        .allow(null, ''), // 建物名・部屋番号等
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required(), // 電話番号
      fax: Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''), // FAX
      charge_name: Joi.string()
        .required()
        .max(255), // 担当者名
      charge_name_kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(512), // 担当者名ふりがな
      department: Joi.string()
        .max(255)
        .allow(null, ''), // 部署
      job_title: Joi.string()
        .max(255)
        .allow(null, ''), // 役職
      email: Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .required(), // メールアドレス
      billing_flag: Joi.allow(null, ''),
      use_partner_company_approval_default_flag: Joi.number(), // 新規現場の作成時の協力会社承認機能のデフォルト値
    };

    this.billing_schema = {
      postal_code: Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .allow(null, ''), // 郵便番号
      prefectures_code_id: Joi.string().allow(null, ''), // 都道府県
      city_name: Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .max(512)
        .allow(null, ''), // 市区町村
      street_number: Joi.string()
        .max(512)
        .allow(null, ''), // 丁目・番地
      building_name: Joi.string()
        .max(512)
        .allow(null, ''), // 建物名・部屋番号等
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, ''), // 電話番号
      fax: Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''), // FAX
      charge_name: Joi.string()
        .max(255)
        .allow(null, ''),
      charge_name_kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .max(512)
        .allow(null, ''),
      department: Joi.string()
        .max(255)
        .allow(null, ''),
      job_title: Joi.string()
        .max(255)
        .allow(null, ''),
      email: Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .allow(null, ''),
    };

    this.billingSchemaKeys = _.map(_.keys(this.billing_schema), value => {
      return `billing_target_${value}`;
    });
  }

  componentWillMount() {
    // フォームに値セット
    CompanyBranchService.showBranch(this.state.branchId).then(response => {
      if (response.result) {
        this.initForm(response.data.entities);
      }
    });
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    UserProfileService.show(this.state.userId).then(response => {
      if (response.result) {
        const entity = response.data.entities;
        this.setState({
          use_greenfile_flg: entity.use_greenfile_flg,
        });
      }
    });
    this.getExpiration();
  }

  /**
   * フォーム生成
   * @param data {object} 会社情報
   */
  initForm(data) {
    const formValues = _.cloneDeep(this.state.formValues);
    _.each(formValues, (value, key) => {
      if (!_.isUndefined(data.company_branch[key])) {
        formValues[key] = _.defaultTo(data.company_branch[key], '');
      }
    });
    formValues.billing_target_id = data.company_branch.billing_target_id;
    if (data.billing_target) {
      _.each(formValues.billing_target, (value, key) => {
        if (data.billing_target[key] !== undefined) {
          formValues.billing_target[key] = _.defaultTo(
            data.billing_target[key],
            ''
          );
        }
      });
    }
    this.setState({ formValues }, () => {
      this.validate();
    });
  }

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 支店情報入力
   * @param name {string}
   * @param value {any}
   */
  setBranch = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = deleteControlCode(value);
    this.setState({ formValues }, () => {
      this.validate({}, name);
    });
    if (name === 'billing_flag') {
      if (value === BILLING_FLAG.on.id) {
        this.delvalidate();
      } else {
        const validate = {};
        validate.invalid =
          !_.isEmpty(this.state.validate.messages) ||
          !_.isEmpty(this.billingValidate.messages);
        validate.messages = {
          ...this.state.validate.messages,
          ...this.billingValidate.messages,
        };
        this.setState({ validate });
      }
      this.checkRequired(formValues);
    }
  };

  /**
   * 請求先情報入力
   * @param name {string}
   * @param value {any}
   */
  setBilling = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues.billing_target[name] = deleteControlCode(value);
    this.setState({ formValues }, () => {
      this.validate({}, name, true);
    });
  };

  /**
   * 入力値の有効判定
   * @return boolean
   */
  validate(e, targetName, billingTrigger) {
    const params = _.cloneDeep(this.state.formValues);
    const schema = this.changeSchema();
    const result = validationByJoi(Joi.object().keys(schema), params);
    const available = result.status;
    if (e || targetName) {
      const validate = _.cloneDeep(this.state.validate);
      const name = _.isEmpty(targetName) ? e.target.name : targetName;
      // billing_targetエラーメッセージ出力
      if (validate.messages[`billing_target_${name}`]) {
        delete validate.messages[`billing_target_${name}`];
        billingTrigger &&
          delete this.billingValidate.messages[`billing_target_${name}`];
        if (!Object.keys(validate.messages).length) {
          validate.invalid = false;
        }
      }
      _.each(result.messages, (value, key) => {
        if (key === 'billing_target' && billingTrigger) {
          _.each(result.messages[key], (billing_value, billing_key) => {
            if (name === billing_key) {
              result.messages[`billing_target_${billing_key}`] = billing_value;
              validate.messages[`billing_target_${name}`] =
                result.messages[`billing_target_${billing_key}`];
              this.billingValidate.messages[`billing_target_${name}`] =
                result.messages[`billing_target_${billing_key}`];
              validate.invalid = true;
            }
          });
        }
      });
      if (result.messages[name]) {
        validate.messages[name] = result.messages[name];
        validate.invalid = true;
      } else if (validate.messages[name]) {
        delete validate.messages[name];
        if (!Object.keys(validate.messages).length) {
          validate.invalid = false;
        }
      }
      if (params.billing_flag === BILLING_FLAG.off.id) {
        validate.invalid =
          !_.isEmpty(validate.messages) ||
          !_.isEmpty(this.billingValidate.messages);
        validate.messages = {
          ...validate.messages,
          ...this.billingValidate.messages,
        };
      }
      this.setState({ validate }, () => {
        this.checkRequired(this.state.formValues);
      });
      return available;
    } else {
      const validate = {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      };
      _.each(result.messages, (value, key) => {
        if (
          key === 'billing_target' &&
          params.billing_flag === BILLING_FLAG.off.id
        ) {
          _.each(result.messages[key], (billing_value, billing_key) => {
            validate.messages[`billing_target_${billing_key}`] = billing_value;
          });
          validate.invalid = true;
        } else if (key !== 'undefined' && key !== 'billing_target') {
          validate.messages[key] = value;
          validate.invalid = true;
        }
      });
      this.setBillingValidate(validate);
      this.setState({ validate }, () => {
        this.checkRequired(this.state.formValues);
      });
      return Object.keys(validate.messages).length === 0;
    }
  }

  /**
   * schema変更
   */
  changeSchema() {
    const billing_schema = this.billing_schema;
    if (this.state.formValues.billing_flag === BILLING_FLAG.off.id) {
      billing_schema.postal_code = Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .required(); // 郵便番号
      billing_schema.prefectures_code_id = Joi.number().required(); // 都道府県
      billing_schema.city_name = Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .max(512)
        .required(); // 市区町村
      billing_schema.street_number = Joi.string()
        .max(512)
        .required(); // 丁目・番地
      billing_schema.building_name = Joi.string()
        .max(512)
        .allow(null, ''); // 建物名・部屋番号等
      billing_schema.tel = Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required(); // 電話番号
      billing_schema.fax = Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''); // FAX
      billing_schema.charge_name = Joi.string()
        .max(255)
        .required(); // 担当者名
      billing_schema.charge_name_kana = Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .max(512)
        .required(); // 担当者名ふりがな
      billing_schema.department = Joi.string()
        .max(255)
        .allow(null, ''); // 部署
      billing_schema.job_title = Joi.string()
        .max(255)
        .allow(null, ''); // 役職
      billing_schema.email = Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .required(); // メールアドレス
    } else {
      billing_schema.postal_code = Joi.number().allow(null, ''); // 郵便番号
      billing_schema.prefectures_code_id = Joi.number().allow(null, ''); // 都道府県
      billing_schema.city_name = Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .max(512)
        .allow(null, ''); // 市区町村
      billing_schema.street_number = Joi.string()
        .max(512)
        .allow(null, ''); // 丁目・番地
      billing_schema.building_name = Joi.string()
        .max(512)
        .allow(null, ''); // 建物名・部屋番号等
      billing_schema.tel = Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, ''); // 電話番号
      billing_schema.fax = Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''); // FAX
      billing_schema.charge_name = Joi.string()
        .max(255)
        .allow(null, ''); // 担当者名
      billing_schema.charge_name_kana = Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .max(512)
        .allow(null, ''); // 担当者名ふりがな
      billing_schema.department = Joi.string()
        .max(255)
        .allow(null, ''); // 部署
      billing_schema.job_title = Joi.string()
        .max(255)
        .allow(null, ''); // 役職
      billing_schema.email = Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .allow(null, ''); // メールアドレス
    }
    // バリデーションパターン結合
    return {
      ...this.schema,
      billing_target: Joi.object(billing_schema),
    };
  }

  setBillingValidate = validate => {
    this.billingValidate.invalid = validate.invalid;
    this.billingValidate.messages = _.pick(
      validate.messages,
      this.billingSchemaKeys
    );
  };

  // 請求先バリデートメッセージ削除
  delvalidate() {
    const validate = _.cloneDeep(this.state.validate);
    this.setBillingValidate(validate);
    _.each(this.billingSchemaKeys, key => {
      delete validate.messages[key];
    });
    validate.invalid = false;
    _.each(validate.messages, (value, key) => {
      if (value !== '') {
        if (key !== 'billing_target' && key !== 'undefined') {
          validate.invalid = true;
        }
      }
    });
    this.setState({ validate });
  }

  isEmptyOrSpaceOnlyStr = str => {
    return isNullOrUndefinedOrEmptyStr(str) || str.trim().length === 0;
  };

  /**
   * 必須入力状況チェック
   * @param values {object} 入力値
   */
  checkRequired(values) {
    // 必須チェック
    const { requiredInput, validate } = _.cloneDeep(this.state);
    let cnt = 0;
    _.each(requiredInput.columns, column => {
      // 支店名は半角・全角スペースのみを許可しない joiのschemaでtrimを指定している項目と合わせる
      if (column === 'name') {
        if (!this.isEmptyOrSpaceOnlyStr(values[column])) {
          cnt++;
        }
      } else if (values[column] && !validate.messages[column]) {
        cnt++;
      }
    });
    if (values.billing_flag === BILLING_FLAG.off.id) {
      _.each(requiredInput.hasBilling, column => {
        if (
          values.billing_target[column] &&
          !validate.messages[`billing_target_${column}`]
        ) {
          cnt++;
        }
      });
    }
    requiredInput.count = cnt;
    requiredInput.total =
      values.billing_flag === BILLING_FLAG.on.id
        ? _.size(requiredInput.columns)
        : _.size(requiredInput.columns) + _.size(requiredInput.hasBilling);

    this.setState({ requiredInput });
  }

  /**
   * 更新
   */
  update = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    const validate = this.validate();
    if (validate === false) {
      this.updatingFlag = false;
      return;
    }

    const safetyValidateResult = this.safetyDocItemValidate();
    if (safetyValidateResult.status === false) {
      this.setSafetyDocErrorMessages(safetyValidateResult);
      this.onOpenSafetyDocItemErrorDialog();
    } else {
      this.submit();
    }
  };

  submit = onceAsyncRequest(async () => {
    await CompanyBranchService.updateBranch(
      this.state.branchId,
      this.state.formValues
    ).then(response => {
      if (response.result) {
        const id = this.props.view.state.id;
        dialogLoader.show(FormInformationDialog, {
          title: '会社情報 支店情報更新',
          message: '会社情報 支店情報の更新が完了しました。',
          onClose: () => {
            dialogLoader.close();
            _masterSlideLoader.show('PrimeBranchPreview', {
              state: { id },
            });
          },
        });
      }
    }).finally(() => {
      this.updatingFlag = false;
    });
  });

  onCloseSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
    });
  };
  onOpenSafetyDocItemErrorDialog = () => {
    this.setState(
      {
        dialogStatus: DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id,
      },
      () => {
        this.updatingFlag = false;
      }
    );
  };

  isUseSafety = () => {
    return this.state.use_greenfile_flg === 1;
  };

  /**
   * 安全書類項目に未入力がないかの確認
   * 安全書類項目は必須ではない
   */
  safetyDocItemValidate = () => {
    // 労務安全が使用できない場合は何もしない
    if (!this.isUseSafety()) {
      return {
        status: true,
      };
    }

    const values = Object.create(null);
    values.building_name = this.state.formValues.building_name;

    const validateSchema = Object.create(null);
    // 建物名・部屋番号等
    validateSchema.building_name = Joi.string().required();

    const result = validationByJoi(validateSchema, values);
    return result;
  };

  setSafetyDocErrorMessages = validateResult => {
    const errorMessages = this.createErrorMessageList(validateResult.messages);
    this.setState({
      confirmationModalSafetyDocItem: {
        errorPropertyList: errorMessages,
      },
    });
  };

  createErrorMessageList = messages => {
    const errorMessages = [];
    Object.keys(messages).forEach(key => {
      const errorPropertyMessage = this.getErrorPropertyMessageByNameKey(key);
      if (errorPropertyMessage !== '') {
        errorMessages.push(errorPropertyMessage);
      }
    });
    return errorMessages;
  };

  getErrorPropertyMessageByNameKey = nameKey => {
    switch (nameKey) {
      case 'building_name':
        return '建物名・部屋番号等';
      default:
        return '';
    }
  };

  render() {
    return (
      <React.Fragment>
        <div id='slide-view' className='contruction-slide-view show'>
          <Helmet>
            <title>{HEADER_CONSTANTS.title} - 会社情報</title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              title={'会社情報'}
              onClose={() => this.events.dialog.goBack()}
            />
            <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <PrimaryCompanyNaviList
                    isSelectedBranchOfficeInformation={true}
                    isEditable={true}
                    expirationCompany={this.state.expirationCompany}
                  />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu'>
                    <span className='construction-detail-view__button'>
                      <button
                        className='btn--sub'
                        onClick={() => this.events.dialog.goBack()}
                      >
                        編集をやめる
                      </button>
                    </span>
                    <span className='construction-detail-view__button'>
                      <button
                        className={`btn--effective ${this.state.validate
                          .invalid && 'btn--disabled'}`}
                        onClick={() => this.events.form.update()}
                        disabled={this.state.validate.invalid}
                      >
                        更新
                      </button>
                    </span>
                    <span
                      className='construction-detail-view__button'
                      style={{
                        right: '120px',
                        color: '#E64E17',
                        fontSize: '12px',
                      }}
                    >
                      {this.state.validate.invalid
                        ? '入力エラーがあります。'
                        : ''}
                    </span>
                    <div className='contruction-detail-view__end-item'>
                      {`必須項目の入力数 ${this.state.requiredInput.count}/${this.state.requiredInput.total}`}
                    </div>
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <CompanyBranchForm
                    values={this.state.formValues}
                    events={this.events.form}
                    messages={this.state.validate.messages}
                    safetyDocItemFlag={this.isUseSafety()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          rootClassName={Style.safetyDocItemErrorDialog}
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.submit();
              this.updatingFlag = false;
            });
          }}
          onCancel={() => {
            this.onCloseSafetyDocItemErrorDialog();
            this.updatingFlag = false;
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrimeBranchEdit.jsx